/**
 * PerformanceCards — Campus vs corporate average comparison (3 cards).
 */

const PerformanceCards = ({ campusName, campusTotal, campusAvgD, campusAvgR, compareTotal, compareAvgD, compareAvgR }) => {
    const buildDelta = (campusVal, corpVal, lowerIsBetter = false) => {
        const cv = parseFloat(campusVal) || 0;
        const av = parseFloat(corpVal) || 0;
        const diff = cv - av;
        const pct = av !== 0 ? ((diff / av) * 100).toFixed(1) : '0.0';

        let cls = 'cd-perf-card__delta--equal';
        let arrow = '→';
        if (Math.abs(diff) > 0.01) {
            if (lowerIsBetter) {
                cls = diff < 0 ? 'cd-perf-card__delta--better' : 'cd-perf-card__delta--worse';
                arrow = diff < 0 ? '↘' : '↗';
            } else {
                cls = diff > 0 ? 'cd-perf-card__delta--worse' : 'cd-perf-card__delta--better';
                arrow = diff > 0 ? '↗' : '↘';
            }
        }
        return { diff: diff > 0 ? `+${diff.toFixed(1)}` : diff.toFixed(1), pct, cls, arrow };
    };

    const totalDelta = buildDelta(campusTotal, compareTotal, false);
    const dailyDelta = buildDelta(campusAvgD, compareAvgD, false);
    const respDelta = buildDelta(campusAvgR, compareAvgR, true);

    return (
        <div className="cd-perf-row">
            <div className="cd-perf-card">
                <div className="cd-perf-card__label">Total Events</div>
                <div className="cd-perf-card__value">{campusTotal ?? 0}</div>
                <span className={`cd-perf-card__delta ${totalDelta.cls}`}>
                    {totalDelta.arrow} {totalDelta.diff} ({totalDelta.pct}%)
                </span>
                <div className="cd-perf-card__avg">Corp avg: {compareTotal ?? 0}</div>
            </div>
            <div className="cd-perf-card">
                <div className="cd-perf-card__label">Daily Average</div>
                <div className="cd-perf-card__value">{campusAvgD ?? 0}</div>
                <span className={`cd-perf-card__delta ${dailyDelta.cls}`}>
                    {dailyDelta.arrow} {dailyDelta.diff} ({dailyDelta.pct}%)
                </span>
                <div className="cd-perf-card__avg">Corp avg: {compareAvgD ?? 0}</div>
            </div>
            <div className="cd-perf-card">
                <div className="cd-perf-card__label">Response Time (min)</div>
                <div className="cd-perf-card__value">{campusAvgR ?? '0.0'}</div>
                <span className={`cd-perf-card__delta ${respDelta.cls}`}>
                    {respDelta.arrow} {respDelta.diff} ({respDelta.pct}%)
                </span>
                <div className="cd-perf-card__avg">Corp avg: {compareAvgR ?? '0.0'}</div>
            </div>
        </div>
    );
};

export default PerformanceCards;
